define('core/utils/cookies',[
], function (
) {
    'use strict';

    var doc = window.document;
    var exports = {
        create: function (name, value, options) {
            if (!options)
                options = {};

            var cookie = name + '=' + value + '; path=' + (options.path || '/');
            var domain = options.domain;
            var expiresIn = options.expiresIn;

            if (domain)
                cookie += '; domain=.' + domain;

            if (Object.prototype.toString.call(expiresIn) === '[object Number]') {
                // expiresIn is in ms
                var date = new Date(new Date().getTime() + expiresIn);
                cookie += '; expires=' + date.toGMTString();
            }

            if (doc.location.protocol === 'https:')
                cookie += '; secure';

            doc.cookie = cookie;
        },

        read: function (name) {
            var nameEQ = name + '=';
            var cookies = doc.cookie.split(';');
            var cookie;

            for (var i = 0; i < cookies.length; i++) {
                cookie = cookies[i].replace(/^\s+/, '');

                if (cookie.indexOf(nameEQ) === 0)
                    return cookie.substring(nameEQ.length);
            }

            return null;
        },

        erase: function (name, options) {
            var cookie = {};
            for (var key in options) {
                if (options.hasOwnProperty(key))
                    cookie[key] = options[key];
            }

            cookie.expiresIn = -1;
            return exports.create(name, '', cookie);
        },


        supported: function () {
            exports.create('cookie_support', '1');
            if (exports.read('cookie_support') === '1') {
                exports.erase('cookie_support');
                return true;
            }
            return false;
        },
    };

    return exports;
});

